export const REGEX_CODE = /^[0-9]*$/;
export const REGEX_RECOVERY_CODE = /^[A-Za-z0-9]*$/;
export const RECOVERY_CODE_LENGTH = 9;
